import React from 'react';
import parse from 'html-react-parser'

import type { Memory } from '../../types/memory';

const MemoryContent: React.FC<{ memory: Memory }> = ({ memory }) => {
  return (
    <div className="memory-content">
      {parse(memory.content || '')}
    </div>
  );
}

export default MemoryContent;
